<template>
	<div class="action">
		<a-card class="visit-count">
			<div class="titles">
				运营账号提成
				<span v-hasPermission="'commission:operateCommissionList'" @click="$router.push({ path: '/commission/operateCommission' })">运营账号提成>></span>
				<span v-hasPermission="'commission:operateCommissionList'" @click="$router.push({ path: '/commission/operateCommissionApproval' })">运营账号提成（待办）>></span>
			</div>
			<a-radio-group v-model="radioType" @change="radioChange">
				<a-badge :count="todoNum"><a-radio-button value="1">待处理</a-radio-button></a-badge>
				<a-radio-button value="2">已处理</a-radio-button>
			</a-radio-group>
			<div class="home-approval">
				<ul class="approval-list">
					<li class="approval-item" v-for="(item, index) in dataList" @click="detail(item)">
						<div style="display: flex;justify-content: space-between;">
							<span class="header">{{ item.commissionApprovalStatus_text + "(" + item.executionContent_text + "|" + item.commissionUserName + ")" }}</span>
							<span>&nbsp;</span>
						</div>
						<span class="commit-time" v-if="radioType == 1">创建时间: {{ item.commissionCreateTime }}</span>
						<span class="commit-time" v-if="radioType == 2">提成月份: {{ item.commissionMonth }}</span>
					</li>
				</ul>
			</div>
		</a-card>

	</div>
</template>

<script>

export default {
	components: {

	},
    data() {
        return {
            dataList: [],
			radioType: '1',
			todoNum: 0,
			qualityContentDialog2: false,
			searchForm: {pageNum: 1,pageSize:4}
        }
    },
	mounted() {
		this.list();
	},
    methods:{
		init() {
			this.radioType = '1';
			this.list();
		},
		radioChange(e) {
			this.radioType = e.target.value;
			this.list();
		},
    	list() {
			this.searchForm.whetherShowAllCommission = 0;
			this.searchForm.approval = 1;
			this.searchForm.commissionState = this.radioType;
			if(this.radioType == '2'){
				this.searchForm.whetherShowAllCommission = 1;
			}
			this.searchForm.pageNum = 1;
			this.searchForm.pageSize = 4;
    		this.$get('order/operateAccountOrderCommissionPage', this.searchForm).then(res => {
    			let result = res.data;
    			this.dataList = result.rows;
				if (this.radioType == '1') {
					this.todoNum = result.total;
					this.$emit("success", this.todoNum);
				}
    		});
    	},
		detail(record){
			if (this.radioType == '2') {
				this.$router.push({ path: '/commission/operateCommission' })
			}
			if (this.radioType == '1') {
				this.$router.push({ path: '/commission/operateCommissionApproval' })
			}
		}
    }
}
</script>



// WEBPACK FOOTER //
// src/views/commission/accountCommissionItem/approvalHome.vue